// apiFetch.js
import { API_BASE } from "../../../config/config";
import { login } from "../utils/auth";

export class ApiAuthError extends Error {
  constructor(status, ...params) {
    super(`API auth error: ${status}`, ...params);
    this.name = "ApiAuthError";
    this.status = status;
  }
}

// Centralized API fetch
export async function apiFetch(path, init) {
  const url = path.startsWith("http") ? path : `${API_BASE}${path}`;
  let res;
  try {
    res = await fetch(url, { credentials: "include", cache: "no-store", ...(init || {}) });
  } catch (e) {
    throw e;
  }

  if (res.status === 401 && !url.includes("/api/me")) {
    // unauthenticated → kick off login (keeps existing behavior)
    login('/home');
    throw new ApiAuthError(401);
  }

  if (res.status === 403 && !url.includes("/api/me")) {
    // authenticated but forbidden — centrally redirect to signed-out forbidden page
    // use replace so user can't go back into the loop
    try {
      // Prefer SPA navigation if available
      if (window && window.location) {
        window.location.replace('/signed-out?reason=forbidden');
      } else {
        // fallback
        window.location.href = '/signed-out?reason=forbidden';
      }
    } catch (e) {
      // last resort
      window.location.href = '/signed-out?reason=forbidden';
    }
    throw new ApiAuthError(403);
  }

  return res;
}
